import _ from 'underscore'
import Vue from 'vue'
import Share from '../../resources/share'
import AcceptShare from '../../resources/acceptShare'


const state = {
  retrievedShares: [],
  selectedShareImportIds: []
};

const getters = {
  receivedShares(state) {
    return _.values(state.retrievedShares);
  },
  selectedShareImportIds(state) {
    if (!state.selectedShareImportIds) return [];
    return state.selectedShareImportIds;
  },
}

const actions = {
  shareChapter(context, payload) {
    Share.save(payload.share).then((res) => {
      context.commit(`CREATE_SHARE_SUCCESS`, { result: res.data });
      if (_.isFunction(payload.callback)) payload.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to share with ' + payload.share.recipient_uid + ': ' + res.body.errors[0]);
    })
  },
  getAllReceivedShares(context, props) {
    Share.query({ recipient: true }).then((res) => {
      context.commit(`RETRIEVE_RECEIVED_SHARES_SUCCESS`, { shares: res.data });
      if (props && _.isFunction(props.callback)) props.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to retrieve shares');
    })
  },
  getAllSentShares(context, props) {
    Share.query({ sender: true }).then((res) => {
      context.commit(`RETRIEVE_SENT_SHARES_SUCCESS`, { shares: res.data });
      if (props && _.isFunction(props.callback)) props.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to retrieve shares');
    })
  },
  acceptShare(context, payload) {
    AcceptShare.save({ id: payload.share.id }).then((res) => {
      context.commit(`ACCEPT_SHARE_SUCCESS`, { share: payload.share });
      if (payload && _.isFunction(payload.callback)) payload.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to retrieve shares');
    })
  },
  deleteShare(context, payload) {
    Share.delete({ id: payload.id }).then((res) => {
      context.commit(`REMOVE_RECEIVED_SHARE`, { id: payload.id });
      context.commit(`REMOVE_SHARE_FROM_IMPORT`, { id: payload.id });
    }, (res) => {
      Toast.error('Failed to delete share')
    })
  },

  addShareToSelected(context, payload) {
    if (!payload.share) {
      return;
    }
    context.commit(`ADD_SHARE_TO_IMPORT`, payload);
  },

  removeShareFromSelected(context, payload) {
    if (!payload.share) {
      return;
    }
    context.commit(`REMOVE_SHARE_FROM_IMPORT`, { id: payload.share.id });
  },
}

const mutations = {
  LOGOUT_SUCCESS() {
    for (let prop in state.retrievedShares) Vue.delete(state, prop);
  },
  
  CREATE_SHARE_SUCCESS(state, payload) {
    
  },

  RETRIEVE_RECEIVED_SHARES_SUCCESS(state, payload) {
    _.each(payload.shares, (share) => {
      if (!share.accepted) {
        Vue.set(state.retrievedShares, share.id, share);
      }
    })
  },

  RETRIEVE_SENT_SHARES_SUCCESS(state, payload) {

  },

  REMOVE_RECEIVED_SHARE(state, payload) {

    Vue.delete(state.retrievedShares, payload.id);
  },

  REMOVE_ALL_RECEIVED_SHARES(state, payload) {
    for (let prop in state.retrievedShares) Vue.delete(state.retrievedShares, prop);
  },

  ACCEPT_SHARE_SUCCESS(state, payload) {
    Vue.delete(state.retrievedShares, payload.share.id);
  },

  ADD_SHARE_TO_IMPORT(state, payload) {
    if (!payload.share) {
      return;
    }
    const share = payload.share;
    state.selectedShareImportIds.push(share.id);

  },

  REMOVE_SHARE_FROM_IMPORT(state, payload) {
    if (!payload.id) {
      return;
    }
    const id = payload.id;
    state.selectedShareImportIds = _.difference(state.selectedShareImportIds, [id]);
  },
}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chapter-sharing.js